// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconThumbsUpGreen = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-thumbs-up-green'}
      data-name='svg-thumbs-up-green'
      data-testid='svg-thumbs-up-green'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '30'}
      height={height ?? '30'}
      viewBox={viewBox ?? '0 0 30 30'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <mask
        id='mask0_707_37368'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='0'
        width='26'
        height='25'
      >
        <path
          d='M2.5 8.65993H7.08755V25H2.5V8.65993ZM11.6751 25H22.7523C23.435 25 24.035 24.5395 24.2226 23.8716L27.3814 12.6279C27.8457 10.9752 26.9056 9.25234 25.2815 8.77983C25.0082 8.70029 24.7252 8.65993 24.4408 8.65993H16.2627L18.3199 2.3791C18.4692 1.92352 18.4033 1.42334 18.1416 1.02377L17.7918 0.489901C17.4607 -0.0155334 16.7897 -0.152112 16.293 0.184844C16.2208 0.233885 16.1545 0.291615 16.0958 0.356786L9.42062 7.76748C8.90357 8.3415 8.61674 9.09191 8.61674 9.8706V21.8876C8.61674 23.6065 9.98602 25 11.6751 25Z'
          fill='#348E30'
        />
      </mask>
      <g mask='url(#mask0_707_37368)'>
        <path d='M33.8489 -6.22479H-2.85156V31.1239H33.8489V-6.22479Z' fill='#348E30' />
      </g>
    </svg>
  );
};

export default IconThumbsUpGreen;
